export default "<div (click)=\"close('close')\">\r\n  <img src=\"{{data.image}}\" style=\"max-width: 800px\">\r\n</div>\r\n"